import { render } from "./MaterialInput.vue?vue&type=template&id=e48b6a58"
import script from "./MaterialInput.vue?vue&type=script&lang=js"
export * from "./MaterialInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/minty.crm.frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__